import _asyncToGenerator from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */
import { util } from '@tensorflow/tfjs-core';
import { Dataset } from '../dataset';
import { TextLineDataset } from './text_line_dataset';
var CODE_QUOTE = '"';
var STATE_OUT = Symbol('out');
var STATE_FIELD = Symbol('field');
var STATE_QUOTE = Symbol('quote');
var STATE_QUOTE_AFTER_QUOTE = Symbol('quoteafterquote');
var STATE_WITHIN_QUOTE_IN_QUOTE = Symbol('quoteinquote');
/**
 * Represents a potentially large collection of delimited text records.
 *
 * The produced `TensorContainer`s each contain one key-value pair for
 * every column of the table.  When a field is empty in the incoming data, the
 * resulting value is `undefined`, or throw error if it is required.  Values
 * that can be parsed as numbers are emitted as type `number`, other values
 * are parsed as `string`.
 *
 * The results are not batched.
 *
 * @doc {heading: 'Data', subheading: 'Classes', namespace: 'data'}
 */
export var CSVDataset = /*#__PURE__*/function (_Dataset) {
  _inherits(CSVDataset, _Dataset);
  /**
   * Create a `CSVDataset`.
   *
   * @param input A `DataSource` providing a chunked, UTF8-encoded byte stream.
   * @param csvConfig (Optional) A CSVConfig object that contains configurations
   *     of reading and decoding from CSV file(s).
   *
   *     hasHeader: (Optional) A boolean value that indicates whether the first
   *     row of provided CSV file is a header line with column names, and should
   *     not be included in the data. Defaults to `true`.
   *
   *     columnNames: (Optional) A list of strings that corresponds to
   *     the CSV column names, in order. If provided, it ignores the column
   *     names inferred from the header row. If not provided, infers the column
   *     names from the first row of the records. If hasHeader is false and
   *     columnNames is not provided, this method throws an error.
   *
   *     columnConfigs: (Optional) A dictionary whose key is column names, value
   *     is an object stating if this column is required, column's data type,
   *     default value, and if this column is label. If provided, keys must
   *     correspond to names provided in columnNames or inferred from the file
   *     header lines. If isLabel is true any column, returns an array of two
   *     items: the first item is a dict of features key/value pairs, the second
   *     item is a dict of labels key/value pairs. If no feature is marked as
   *     label, returns a dict of features only.
   *
   *     configuredColumnsOnly (Optional) If true, only columns provided in
   *     columnConfigs will be parsed and provided during iteration.
   *
   *     delimiter (Optional) The string used to parse each line of the input
   *     file. Defaults to `,`.
   */
  function CSVDataset(input, csvConfig) {
    var _this;
    _classCallCheck(this, CSVDataset);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CSVDataset).call(this));
    _this.input = input;
    _this.hasHeader = true;
    _this.fullColumnNames = null;
    _this.columnNamesValidated = false;
    _this.columnConfigs = null;
    _this.configuredColumnsOnly = false;
    _this.delimiter = ',';
    _this.delimWhitespace = false;
    _this.base = new TextLineDataset(input);
    if (!csvConfig) {
      csvConfig = {};
    }
    _this.hasHeader = csvConfig.hasHeader === false ? false : true;
    _this.fullColumnNames = csvConfig.columnNames;
    _this.columnConfigs = csvConfig.columnConfigs;
    _this.configuredColumnsOnly = csvConfig.configuredColumnsOnly;
    if (csvConfig.delimWhitespace) {
      util.assert(csvConfig.delimiter == null, function () {
        return 'Delimiter should not be provided when delimWhitespace is true.';
      });
      _this.delimWhitespace = true;
      _this.delimiter = ' ';
    } else {
      _this.delimiter = csvConfig.delimiter ? csvConfig.delimiter : ',';
    }
    return _this;
  }
  /**
   * Returns column names of the csv dataset. If `configuredColumnsOnly` is
   * true, return column names in `columnConfigs`. If `configuredColumnsOnly` is
   * false and `columnNames` is provided, `columnNames`. If
   * `configuredColumnsOnly` is false and `columnNames` is not provided, return
   * all column names parsed from the csv file. For example usage please go to
   * `tf.data.csv`.
   *
   * @doc {heading: 'Data', subheading: 'Classes'}
   */
  _createClass(CSVDataset, [{
    key: "columnNames",
    value: function () {
      var _columnNames = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.columnNamesValidated) {
                  _context.next = 3;
                  break;
                }
                _context.next = 3;
                return this.setColumnNames();
              case 3:
                return _context.abrupt("return", this.configuredColumnsOnly ? Object.keys(this.columnConfigs) : this.fullColumnNames);
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function columnNames() {
        return _columnNames.apply(this, arguments);
      }
      return columnNames;
    }()
    /* 1) If `columnNames` is provided as string[], use this string[] as output
     * keys in corresponding order. The length must match the number of inferred
     * columns if `hasHeader` is true .
     * 2) If `columnNames` is not provided, parse header line as `columnNames` if
     * hasHeader is true. If `hasHeader` is false, throw an error.
     * 3) If `columnConfigs` is provided, all the keys in `columnConfigs` must
     * exist in parsed `columnNames`.
     */
  }, {
    key: "setColumnNames",
    value: function () {
      var _setColumnNames = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this2 = this;
        var columnNamesFromFile, counts, duplicateNames, _i, _Object$keys, key, index;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.maybeReadHeaderLine();
              case 2:
                columnNamesFromFile = _context2.sent;
                if (!(!this.fullColumnNames && !columnNamesFromFile)) {
                  _context2.next = 7;
                  break;
                }
                throw new Error('Column names must be provided if there is no header line.');
              case 7:
                if (this.fullColumnNames && columnNamesFromFile) {
                  // Check provided columnNames match header line.
                  util.assert(columnNamesFromFile.length === this.fullColumnNames.length, function () {
                    return 'The length of provided columnNames (' + _this2.fullColumnNames.length.toString() + ') does not match the length of the header line read from ' + 'file (' + columnNamesFromFile.length.toString() + ').';
                  });
                }
              case 8:
                if (!this.fullColumnNames) {
                  this.fullColumnNames = columnNamesFromFile;
                }
                // Check if there are duplicate column names.
                counts = this.fullColumnNames.reduce(function (countAcc, name) {
                  countAcc[name] = countAcc[name] + 1 || 1;
                  return countAcc;
                }, {});
                duplicateNames = Object.keys(counts).filter(function (name) {
                  return counts[name] > 1;
                });
                util.assert(duplicateNames.length === 0, function () {
                  return 'Duplicate column names found: ' + duplicateNames.toString();
                });
                // Check if keys in columnConfigs match columnNames.
                if (!this.columnConfigs) {
                  _context2.next = 22;
                  break;
                }
                _i = 0, _Object$keys = Object.keys(this.columnConfigs);
              case 14:
                if (!(_i < _Object$keys.length)) {
                  _context2.next = 22;
                  break;
                }
                key = _Object$keys[_i];
                index = this.fullColumnNames.indexOf(key);
                if (!(index === -1)) {
                  _context2.next = 19;
                  break;
                }
                throw new Error('The key "' + key + '" provided in columnConfigs does not match any of the column ' + 'names (' + this.fullColumnNames.toString() + ').');
              case 19:
                _i++;
                _context2.next = 14;
                break;
              case 22:
                this.columnNamesValidated = true;
              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function setColumnNames() {
        return _setColumnNames.apply(this, arguments);
      }
      return setColumnNames;
    }()
  }, {
    key: "maybeReadHeaderLine",
    value: function () {
      var _maybeReadHeaderLine = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var iter, firstElement, firstLine, headers;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.hasHeader) {
                  _context3.next = 14;
                  break;
                }
                _context3.next = 3;
                return this.base.iterator();
              case 3:
                iter = _context3.sent;
                _context3.next = 6;
                return iter.next();
              case 6:
                firstElement = _context3.sent;
                if (!firstElement.done) {
                  _context3.next = 9;
                  break;
                }
                throw new Error('No data was found for CSV parsing.');
              case 9:
                firstLine = firstElement.value;
                headers = this.parseRow(firstLine, false);
                return _context3.abrupt("return", headers);
              case 14:
                return _context3.abrupt("return", null);
              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function maybeReadHeaderLine() {
        return _maybeReadHeaderLine.apply(this, arguments);
      }
      return maybeReadHeaderLine;
    }()
  }, {
    key: "iterator",
    value: function () {
      var _iterator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this3 = this;
        var lines;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.columnNamesValidated) {
                  _context4.next = 3;
                  break;
                }
                _context4.next = 3;
                return this.setColumnNames();
              case 3:
                _context4.next = 5;
                return this.base.iterator();
              case 5:
                lines = _context4.sent;
                if (this.hasHeader) {
                  // We previously read the first line to get the columnNames.
                  // Now that we're providing data, skip it.
                  lines = lines.skip(1);
                }
                return _context4.abrupt("return", lines.map(function (x) {
                  return _this3.makeDataElement(x);
                }));
              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function iterator() {
        return _iterator.apply(this, arguments);
      }
      return iterator;
    }()
  }, {
    key: "makeDataElement",
    value: function makeDataElement(line) {
      var values = this.parseRow(line);
      var features = {};
      var labels = {};
      for (var i = 0; i < this.fullColumnNames.length; i++) {
        var key = this.fullColumnNames[i];
        var config = this.columnConfigs ? this.columnConfigs[key] : null;
        if (this.configuredColumnsOnly && !config) {
          // This column is not selected.
          continue;
        } else {
          var value = values[i];
          var parsedValue = null;
          if (value === '') {
            // If default value is provided, use it. If default value is not
            // provided, set as undefined.
            if (config && config.default !== undefined) {
              parsedValue = config.default;
            } else if (config && (config.required || config.isLabel)) {
              throw new Error("Required column ".concat(key, " is empty in this line: ").concat(line));
            } else {
              parsedValue = undefined;
            }
          } else {
            // A value is present, so parse it based on type
            var valueAsNum = Number(value);
            if (isNaN(valueAsNum)) {
              // The value is a string and this column is declared as boolean
              // in config, parse it as boolean.
              if (config && config.dtype === 'bool') {
                parsedValue = this.getBoolean(value);
              } else {
                // Set value as string
                parsedValue = value;
              }
            } else if (!config || !config.dtype) {
              // If this value is a number and no type config is provided, return
              // it as number.
              parsedValue = valueAsNum;
            } else {
              // If this value is a number and data type is provided, parse it
              // according to provided data type.
              switch (config.dtype) {
                case 'float32':
                  parsedValue = valueAsNum;
                  break;
                case 'int32':
                  parsedValue = Math.floor(valueAsNum);
                  break;
                case 'bool':
                  parsedValue = this.getBoolean(value);
                  break;
                default:
                  parsedValue = valueAsNum;
              }
            }
          }
          // Check if this column is label.
          config && config.isLabel ? labels[key] = parsedValue : features[key] = parsedValue;
        }
      }
      // If label exists, return an object of features and labels as {xs:features,
      // ys:labels}, otherwise return features only.
      if (Object.keys(labels).length === 0) {
        return features;
      } else {
        return {
          xs: features,
          ys: labels
        };
      }
    }
  }, {
    key: "getBoolean",
    value: function getBoolean(value) {
      if (value === '1' || value.toLowerCase() === 'true') {
        return 1;
      } else {
        return 0;
      }
    } // adapted from https://beta.observablehq.com/@mbostock/streaming-csv
  }, {
    key: "parseRow",
    value: function parseRow(line) {
      var validateElementCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var result = [];
      var readOffset = 0;
      var readLength = line.length;
      var currentState = STATE_OUT;
      // Goes through the line to parse quote.
      for (var i = 0; i < readLength; i++) {
        switch (currentState) {
          // Before enter a new field
          case STATE_OUT:
            switch (line.charAt(i)) {
              // Enter a quoted field
              case CODE_QUOTE:
                readOffset = i + 1;
                currentState = STATE_QUOTE;
                break;
              // Read an empty field
              case this.delimiter:
                readOffset = i + 1;
                // If delimiter is white space and configured to collapse
                // multiple white spaces, ignore this white space.
                if (this.delimiter === ' ' && this.delimWhitespace) {
                  break;
                }
                result.push('');
                currentState = STATE_OUT;
                break;
              // Enter an unquoted field
              default:
                currentState = STATE_FIELD;
                readOffset = i;
                break;
            }
            break;
          // In an unquoted field
          case STATE_FIELD:
            switch (line.charAt(i)) {
              // Exit an unquoted field, add it to result
              case this.delimiter:
                result.push(line.substring(readOffset, i));
                currentState = STATE_OUT;
                readOffset = i + 1;
                break;
              default:
            }
            break;
          // In a quoted field
          case STATE_QUOTE:
            switch (line.charAt(i)) {
              // Read a quote after a quote
              case CODE_QUOTE:
                currentState = STATE_QUOTE_AFTER_QUOTE;
                break;
              default:
            }
            break;
          // This state means it's right after a second quote in a field
          case STATE_QUOTE_AFTER_QUOTE:
            switch (line.charAt(i)) {
              // Finished a quoted field
              case this.delimiter:
                result.push(line.substring(readOffset, i - 1));
                currentState = STATE_OUT;
                readOffset = i + 1;
                break;
              // Finished a quoted part in a quoted field
              case CODE_QUOTE:
                currentState = STATE_QUOTE;
                break;
              // In a quoted part in a quoted field
              default:
                currentState = STATE_WITHIN_QUOTE_IN_QUOTE;
                break;
            }
            break;
          case STATE_WITHIN_QUOTE_IN_QUOTE:
            switch (line.charAt(i)) {
              // Exit a quoted part in a quoted field
              case CODE_QUOTE:
                currentState = STATE_QUOTE;
                break;
              default:
            }
            break;
          default:
        }
      }
      // Adds last item based on if it is quoted.
      if (currentState === STATE_QUOTE_AFTER_QUOTE) {
        result.push(line.substring(readOffset, readLength - 1));
      } else {
        result.push(line.substring(readOffset));
      }
      // Check if each row has the same number of elements as column names.
      if (validateElementCount && result.length !== this.fullColumnNames.length) {
        throw new Error("Invalid row in csv file. Should have ".concat(this.fullColumnNames.length, " elements in a row, but got ").concat(result));
      }
      return result;
    }
  }]);
  return CSVDataset;
}(Dataset);
// TODO(soergel): add more basic datasets for parity with tf.data
// tf.data.FixedLengthRecordDataset()
// tf.data.TFRecordDataset()